import { auth } from "../firebase/firebase";
import { onIdTokenChanged, User } from "firebase/auth";

export const getCurrentToken = () => new Promise<string>((resolve, reject) => {
  const uns = onIdTokenChanged(auth, async (user: User | null) => {
    uns();

    if (user) {
      const token = await user.getIdToken();
      resolve(token);
      return;
    }

    reject(new Error("No autentificado."));
  }, reject);
});
